module.exports = __webpack_public_path__ + "static/img/EP202504081424409.6a046f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/detail/EP202504081424409.jpg
// module id = ilpn
// module chunks = 1